module.exports = __webpack_public_path__ + "img/oax.cebb56b0.svg";